import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { Input } from "../../../ui/input";
import { useEffect } from "react";

export const ChangeSlug = ({ children, setSlug }: { children: React.ReactNode, setSlug: any }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [slug, setSlugC] = useState("");
    const [password, setPassword] = useState("");
    const [slugError, setSlugError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        const slugRegex = /^[a-zA-Z0-9-]*$/;
        if(!slug) {setSlugError(""); setDisabled(true); return;}
        if(slug.length < 3 || slug.length > 20) {setSlugError("Slug must be 3-20 characters long"); setDisabled(true); return;}
        if (slugRegex.test(slug)) {setSlugError(""); setDisabled(false);}
        else {setSlugError("Slug can only contain letters, numbers, and dashes"); setDisabled(true);}
    }, [slug]);

    useEffect(() => {
        if(!password) {setPasswordError(""); setDisabled(true); return;} 
        if(String(password).length >= 6) {setPasswordError(""); setDisabled(false);}
        else {setPasswordError("Password must be at least 6 characters long"); setDisabled(true);}
    }, [password]);

    const requestSlug = async () => {
        setDisabled(true);
        const response = await fetch('__SITE_BASE__/api/me/profile/slug', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ slug, password }),
        });
        const data = await response.json();
        if(!data.success) {
            setPasswordError(data?.errors?.password);
            setSlugError(data?.errors?.slug);
            setDisabled(false);
            return;
        }
        setPassword("");
        setPasswordError("");
        setSlugError("");
        setSlug(data.slug);
        setIsOpen(false);
    }
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                <DialogHeader className="items-start justify-start">
                    <DialogTitle>
                        Change your slug
                    </DialogTitle>
                <DialogDescription/>
                </DialogHeader>
                    
                <div className="flex flex-col space-y-4">
                    {slugError && <div className="text-red-500">{slugError}</div>}
                    <Input
                        type="text"
                        id="Slug"
                        className="bg-brand-back rounded border-0"
                        value={slug}
                        onChange={(e) => setSlugC(e.target.value)}
                        placeholder="Slug"
                        autoComplete="off"
                        
                    />
                    {passwordError && <div className="text-red-500">{passwordError}</div>}
                    <Input
                        type="password"
                        id="password"
                        className="bg-brand-back rounded border-0"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                    />
                    <div className="flex justify-end">
                        <Button
                            onClick={() => {
                                requestSlug();
                            }}
                            
                            className="bg-brand-green px-5 py-2 rounded-lg text-white font-semibold hover:bg-green-500"
                            disabled={disabled}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
